<div class="modal-header">
    <h4 class="modal-title">{{data.deviceName}} {{data.id ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deliveryDeviceForm">
        <div class="form-group col-xl-12 col-md-12 col-sm-12">
            <label for="company">Sertfika Basılacak Firma</label>
            <div class="form-group">
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer d-flex">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!deliveryDeviceForm.valid" (click)="data.id ? onUpdateSave() : saveDeliveryDevice()">Kaydet</button>
</div>